var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#262a2e",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M283.08-409.23q14.69 0 25.04-10.35 10.34-10.34 10.34-25.04 0-14.69-10.34-25.03Q297.77-480 283.08-480t-25.04 10.35q-10.35 10.34-10.35 25.03 0 14.7 10.35 25.04 10.35 10.35 25.04 10.35Zm0-115.39q14.69 0 25.04-10.34 10.34-10.35 10.34-25.04t-10.34-25.04q-10.35-10.34-25.04-10.34t-25.04 10.34q-10.35 10.35-10.35 25.04t10.35 25.04q10.35 10.34 25.04 10.34Zm0-115.38q14.69 0 25.04-10.35 10.34-10.34 10.34-25.03 0-14.7-10.34-25.04-10.35-10.35-25.04-10.35t-25.04 10.35q-10.35 10.34-10.35 25.04 0 14.69 10.35 25.03Q268.39-640 283.08-640Zm121.54 225.38H590v-59.99H404.62v59.99Zm0-115.38H710v-60H404.62v60Zm0-115.39H710v-59.99H404.62v59.99ZM100-118.46v-669.23Q100-818 121-839q21-21 51.31-21h615.38Q818-860 839-839q21 21 21 51.31v455.38Q860-302 839-281q-21 21-51.31 21H241.54L100-118.46ZM216-320h571.69q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46v-455.38q0-4.62-3.85-8.46-3.84-3.85-8.46-3.85H172.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46v523.08L216-320Zm-56 0v-480 480Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatsIcon);
export default __webpack_public_path__ + "static/media/chats_icon.a636dbf12c2312b469cf3bfe1e7ad7f4.svg";
export { ForwardRef as ReactComponent };